module.exports = __webpack_public_path__ + "static/media/bear.cb140f3e.svg";